import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// sample page routing
const Dashboard = Loadable(lazy(() => import('views/recipient/dashboard')));
const RecipientMetrics = Loadable(lazy(() => import('views/recipient/metrics/RecipientMetrics')));
const RecipientRoutineRoutesPage = Loadable(lazy(() => import('views/recipient/routine-donations/RecipientRoutineRoutesPage')));
const RecipientOnDemandRoutesPage = Loadable(lazy(() => import('views/recipient/on-demand-donations/RecipientOnDemandRoutesPage')));
const RecipientRequestsPage = Loadable(lazy(() => import('views/recipient/requests/RecipientRequestsPage')));
const RecipientMarketplacePage = Loadable(lazy(() => import('views/recipient/marketplace/RecipientMarketplacePage')));
const UpdateProfilePage = Loadable(lazy(() => import('views/recipient/profile/RecipientUpdateProfile')));

// ==============================|| MAIN ROUTING ||============================== //

const RecipientRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <Dashboard />
        },
        {
            path: '/dashboard',
            element: <Dashboard />
        },
        {
            path: '/metrics',
            element: <RecipientMetrics key="metrics" />,
        },
        {
            path: '/upcoming-routine-donations',
            element: <RecipientRoutineRoutesPage upcoming={true} key="routine-upcoming" />,
        },
        {
            path: '/past-routine-donations',
            element: <RecipientRoutineRoutesPage upcoming={false} key="routine-past" />,
        },
        {
            path: '/upcoming-on-demand-donations',
            element: <RecipientOnDemandRoutesPage upcoming={true} key="on-demand-upcoming" />,
        },
        {
            path: '/past-on-demand-donations',
            element: <RecipientOnDemandRoutesPage upcoming={false} key="on-demand-past" />,
        },
        {
            path: '/requests',
            element: <RecipientRequestsPage key="create" />,
        },
        {   
            path: '/marketplace',
            element: <RecipientMarketplacePage key="marketplace" />,
        
        },
        {
            path: '/user/update-profile',
            element: <UpdateProfilePage />
        },
    ]
};

export default RecipientRoutes;
